<template>
	<Nuisance>
		<template #header>
			<Header />
		</template>
	</Nuisance>
</template>

<script setup lang="ts">
import Header from "@/rmo/components/Header.vue";
import Nuisance from "@/rmo/content/Nuisance.vue";
</script>
